import { render } from "./policy.vue?vue&type=template&id=cb62f502&scoped=true"
import script from "./policy.vue?vue&type=script&lang=js"
export * from "./policy.vue?vue&type=script&lang=js"

import "./policy.vue?vue&type=style&index=0&id=cb62f502&lang=less&scoped=true"

import exportComponent from "D:\\workstudio\\website67\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb62f502"]])

export default __exports__